export enum WHITE {
  DEFAULT = '#FFFFFF',
}
